import React from 'react';
import { connect } from 'react-redux';
import { Button, Input, Modal, message } from 'antd';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import { saveSearchParams } from '../../actions/noticeActions';
import { saveParams } from '../../actions/homeActions';
import CryptoJS from 'crypto-js'

// CTA, 超级管理员
// CTA, //系统管理员
// EA, //企业管理员
// BO, //总监
// BDO, //BD总监
// BD,
// PA, //项目管理员
// PM, //项目经理
// CRCC, //CRC主管
// CRCM, //CRC经理
// CRC, //临床协调员
// CPM, //客户项目经理
// PI, //研究者
// CRA, //监察员
// OTH, //其它

class Login extends React.Component {
    state = {
        employeeCode: '',
        passCode: '',
    }

    getCrcEvaluateRemindMessage = () => {
        const options = {
            url: API_URL.notice.getCrcEvaluateRemindMessage,
            data: {},
            dataType: 'json',
            doneResult: (res) => {
                const { data } = res;
                if ((data || []).length) {
                    this.props.saveParams({
                        showCrcQualitySheet: true,
                        qualitySheetNewsList: data,
                    });
                }
                location.href = `./#/home`;
            },
        };
        $.sendRequest(options);
    }

    login = () => {
        const { employeeCode, passCode } = this.state;
        if (!employeeCode || (employeeCode && employeeCode.trim() == '') ||
            !passCode || (passCode && passCode.trim() == '')) {
            Modal.error({ title: "错误", content: "登录名或密码不能为空" });
            return;
        }
        localStorage.clear();
        sessionStorage.clear();
        const options = {
            url: API_URL.config.login,
            data: { 
                name: employeeCode,
                password: CryptoJS.SHA1(passCode).toString(),
            },
            dataType: 'json',
            doneResult: res => {
                // const { positionRole, user = {} } = res.data;
                // const { userId = '', enterpriseId = '', employeeCode = '',  positionName, userCompellation = '' } = user;
                const { role, errorCode, message: messageText, success, redirectUrl } = res;
                if(errorCode == 401) {
                    Modal.confirm({
                        title: messageText,
                        onOk(){
                            location.href = redirectUrl
                        },
                    })
                } else if(errorCode == 406 && error ) {
                    message.error(error);
                } else if(success) {
                    const { tokenInfo: { tokenName, tokenValue, loginType }, employeeCode: userCode } = res;
                    message.success('登录成功！');
                    sessionStorage.employeeCode = userCode;
                    sessionStorage.curRole = role;
                    sessionStorage.positionRole = role;
                    localStorage.setItem('tokenValue', tokenValue);
                    localStorage.setItem('tokenName', tokenName);
                    localStorage.setItem('loginType', loginType || 'ADFS');
                    localStorage.setItem('is401', 0);
                    location.href = `./#/home`;
                }
                // sessionStorage.curRole = positionRole || '';
                // sessionStorage.positionRole = positionRole || '';
                // sessionStorage.positionName = positionName || '';
                // sessionStorage.userId = userId;
                // sessionStorage.userName = userCompellation;
                // sessionStorage.curEnterpriseId = enterpriseId;
                // sessionStorage.curEmployeeCode = employeeCode;
                // sessionStorage.invName = '';
                // sessionStorage.invId = '';
                // sessionStorage.siteId = '';

                // if (positionRole == 'PA') {
                //     location.href = `./#/invList`;
                // } else {
                //     //预计工时调整提醒
                //     const { adjustmentNotices: list } = res.data;
                //     if (list && list.length && list.some(i => (i.status == 'NEW' || i.status == 'DELAY'))) {
                //         this.props.saveParams({ expectHour: true });
                //         this.props.saveSearchParams({ 
                //             noticeType: 'PLAN_FTE_ADJUSTMENT', 
                //             noticeValue:'预计工时调整提醒', 
                //             activeKey:'Notice',  
                //         });
                //     }
                //     //中心关联提醒
                //     {
                //         const { contactSiteNotices: list } = res.data;
                //         if (list && list.length ) {
                //             this.props.saveParams({ centerRelate: true });
                //             this.props.saveSearchParams({ 
                //                 noticeType: 'CONTRACT_RELATE_SITE', 
                //                 noticeValue:'中心关联合同通知', 
                //                 activeKey:'Notice',
                //             });
                //         }
                //     }
                //     //办事流程确认提醒
                //     {
                //         const { ssuHospitalNotices: list } = res.data;
                //         if (list && list.length ) {
                //             this.props.saveParams({ infoConfirm: true });
                //             this.props.saveSearchParams({ 
                //                 noticeType: 'SSU_HOSPITAL_INFO_CONFIRM', 
                //                 noticeValue:'办事流程确认提醒', 
                //                 activeKey:'Backlog',
                //             });
                //         }
                //     }
                //     if (positionRole === 'CRC') {
                //         this.getCrcEvaluateRemindMessage();
                //     } else {
                //         location.href = `./#/home`;
                //     }
                // }
            },
            errorResult: (res) => {
                console.log(res);
            },
            failResult: (res) => {
                console.log(res);
            }
        };
        $.sendRequest(options);
    }

    nameInput = e => {
        this.setState({
            employeeCode: e.target.value,
        });
    }

    passInput = e => {
        this.setState({
            passCode: e.target.value,
        });
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.login();
        }
    }

    render() {
        sessionStorage.invId = '';
        sessionStorage.siteId = '';
        sessionStorage.curRole = '';
        return (
            <div className="index-login" >
                <div className="header">
                    <div className="logo"></div>
                </div>
                <div className="wrap-login">
                    <div className="con-bg"></div>
                    <div className='login form-signin' style={{display:'inline-block', float:'right'}} >   
                        <div className="form-signin-heading">SMO临床试验管理系统</div>             
                        <Input className="form-control" id="username" onBlur={this.nameInput} onKeyPress={this.enterSearch} placeholder="员工号" />
                        <Input className="form-control" type="password" id="password" onBlur={this.passInput} onKeyPress={this.enterSearch} placeholder="密码" />
                        <Button className="btn btn-lg btn-primary btn-block" id="loginBtn" type="primary" onClick={this.login}>登录</Button>
                    </div>
                </div>
                <div className="footer">
                    <div className="footerWrap">
                        <p>版权所有&copy; 上海津石医药科技有限公司    技术支持:无锡慧方科技有限公司</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveSearchParams: (params) => dispatch(saveSearchParams(params))
    }
}

export default connect(null, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/home/Login.js